<template>
  <div class="asc-derived-parameter-list-template">
    <v-row no-gutters class="pb-6">
      <v-col cols="12" xs="12" sm="6" align-self="center">
        Create new, duplicate, or delete custom parameters.
      </v-col>
      <v-col
        v-if="values.length"
        cols="12"
        xs="12"
        sm="6"
        class="d-flex justify-end pr-2"
        align-self="center"
      >
        <asc-accent-button
          button-text="CUSTOM PARAMETER"
          icon="mdi-plus"
          icon-position="left"
          :on-click="handleAddNewParameter"
        />
      </v-col>
    </v-row>
    <v-row v-if="!loading" no-gutters>
      <v-col cols="12" sm="12">
        <asc-derived-parameter-grid-wrapper
          :values="values"
          :hide-action-footer="hideActionFooter"
          :is-airline-user="isAirlineUser"
          :user-airlines="userAirlines"
          :deselect-all-user-guides="deselectAllDerivedParameters"
          :grid-disabled="gridDisabled"
          :loading="loading"
          v-on="$listeners"
          @onDeleteDerivedParameters="handleDeleteDerivedParameters"
          @openAlertTypeDialog="handleOpenAlertTypeDialog"
          @copyParameter="handleCopyParameter"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import AscAccentButton from '@/components/atoms/AscAccentButton'
import AscTab from '@/components/atoms/AscTab'
import AscTabBody from '@/components/atoms/AscTabBody'
import AscTabItem from '@/components/atoms/AscTabItem'
import AscTabTitle from '@/components/atoms/AscTabTitle'

import AscDerivedParameterGridWrapper from '@/components/organisms/AscDerivedParameterGridWrapper'

import AppFeatureFlags from '@/utilities/appFeatureFlags'

export default {
  name: 'AscDerivedParameterListTemplate',

  components: {
    AscDerivedParameterGridWrapper,
    AscAccentButton,
    AscTab,
    AscTabBody,
    AscTabItem,
    AscTabTitle,
  },

  props: {
    tabIndex: {
      type: Number,
      default: 0,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    onTabChange: {
      type: Function,
      default: () => {},
    },
    values: {
      type: Array,
      required: true,
      default: () => [],
    },
    hideActionFooter: {
      type: Boolean,
      default: false,
    },
    isAirlineUser: {
      type: Boolean,
      default: false,
    },
    userAirlines: {
      type: Array,
      default: () => [],
    },
    gridDisabled: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      tab: 0,
      deselectAllDerivedParameters: false,
    }
  },
  computed: {
    isDerivedParametersPageActive() {
      return AppFeatureFlags.getDerivedParameters()
    },

    model: {
      get() {
        return this.tab
      },
      set(newVal) {
        this.tab = newVal
        if (this.onTabChange) {
          this.onTabChange(newVal)
        }
      },
    },
  },
  watch: {
    tabIndex(newValue) {
      this.tab = newValue
    },
  },

  methods: {
    handleDeleteDerivedParameters(whichParameters) {
      this.$emit('onDeleteDerivedParameters', whichParameters)
    },

    handleAddNewParameter() {
      this.$emit('onAddNewParameter')
    },

    handleOpenAlertTypeDialog() {
      this.$emit('openAlertTypeDialog')
    },

    handleCopyParameter(arg) {
      this.$emit('copyParameter', arg)
    },
  },
}
</script>

<style lang="scss">
.asc-derived-parameter-list-template {
  #asc-main-tabs.asc-tabs {
    .v-tabs-bar__content {
      background-color: $primary-white !important;
    }
  }

  .asc-tab__content--primary {
    background-color: $primary-white !important;
    padding: 0 !important;

    .asc-main-tab-item {
      .asc-tab__content--secondary {
        .asc-tab__content--primary {
          background-color: $gray-0 !important;
        }
      }
    }
  }
}
</style>
